import { proxy } from 'valtio';

interface NativeEmbedState {
  isFullscreen: boolean;
  isSelected: boolean;
  showTitle: boolean;
}

export const nativeEmbedState = proxy<NativeEmbedState>({
  isFullscreen: false,
  isSelected: false,
  showTitle: true,
});
